
import { Field } from '@docma-mm-core/field/field'
import { SortDirectionEnum } from '@docma-mm-core/sorting/sort-direction.enum';

export class LayoutSortItem {
  constructor(init: Partial<LayoutSortItem>) {
    if (init) {
      Object.assign(this, init);
    }
  }
  Field: Field;
  Direction: SortDirectionEnum;
  IsGroupSorting: boolean;
}
